export default {
  supportedDevices: {
    android: ['Android版'],
    ios: ['iOS版'],
    ar: ['AR機能について'],
    incompatible: ['非対応機種'],
    compatible: ['対応機種']
  }
};
